export function formatConsignmentProvider(provider: any): string {
  if (!provider?.data) return '';
  const d = provider.data;
  if (d.name && d.name.length > 0) return d.name;
  return `${d.first_name ?? ''} ${d.last_name ?? ''}`.trim();
}
